import { rem } from '@innovyze/stylovyze';
import styled from 'styled-components';

export const SubscriptionsCardContainer = styled.div`
	display: grid;
	grid-gap: ${rem(24)};
	grid-template-columns: repeat(auto-fill, minmax(${rem(350)}, 1fr));
`;
